import { jsx } from "react/jsx-runtime";
import Button from "../Button/Button.js";
import classnames from "../../utils/classnames.js";
const DealerInfoButtons = ({ items, className }) => {
  return /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-dealer-info-buttons", className), children: items.map(({ icon, type, className: className2, children, ...props }, i) => /* @__PURE__ */ jsx(
    Button,
    {
      type: type || "ghost",
      icon,
      target: "_blank",
      rel: "noopener",
      className: classnames("perxis-auto-dealer-info-buttons__button", className2),
      ...props,
      children
    },
    i
  )) });
};
export {
  DealerInfoButtons as default
};
//# sourceMappingURL=DealerInfoButtons.js.map
